// 公共模块
export const G                                   = {
	blog                                         : 'my blog`s admin',
}

export const lang                                = {
	auto                                         : 'Automatic Detection',
	zh                                           : 'Simplified Chinese',
	tw                                           : 'chinese traditional',
	en                                           : 'English',
	ja                                           : 'Japanese',
}


// WEBPACK FOOTER //
// ./src/assets/lang/en.js